export const isBurgerservicenummerGeldig = (bsn: string): boolean => {
  if (bsn.length === 8) {
    bsn = `0${bsn}`;
  }

  let i = 9;

  if (bsn.length !== 9) {
    return false;
  }

  const number = parseInt(bsn);

  if (isNaN(number)) {
    return false;
  }

  let total = 0;

  for (let j = 0; j < bsn.length - 1; j++) {
    const t = bsn[j];
    total += parseInt(t) * i;
    i--;
  }

  const laatsteGetalVanBsn = parseInt(bsn[8]);

  return total !== 0 && total % 11 === laatsteGetalVanBsn;
};

export const isRelatienummerGeldig = (relatienummer: string): boolean => {
  relatienummer = relatienummer.trim();

  return !isNaN(Number(relatienummer)) && Number(relatienummer) > 0 && relatienummer.length <= 10;
};
